import React from 'react'
import '../styles/pages/activities/hor-gallery.scss'

export default function HorGallery({children}) {
    return (
        <div className="hor-gallery">
            {children}
        </div>
    )
}
 